// extracted by mini-css-extract-plugin
export default {"iosSafeAreaOffset":"IosSafeAreaTop_iosSafeAreaOffset__0Qc1F","iosSafeAreaPlaceholder":"IosSafeAreaTop_iosSafeAreaPlaceholder__osoFM"};